<template>
  <NuxtLayout name="base-list">
    <template #navigation>
      <BaseNavigationBar
        :title="t('На главную')"
        has-click-back
        @click-back="navigateTo(permissions.WORKSPACE.ROUTE)"
      />
    </template>
    <BaseErrorWrapper src="/500.webp" :text="t('Что-то пошло не так')" />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { BaseErrorWrapper, BaseNavigationBar } from '~/shared/ui'

import i18n from './error.i18n.json'
import { permissions } from './shared/lib'

const { t } = useI18n(i18n)
</script>
